import { Action } from '../action';
import { AuthType } from '../Auth/action';
import { PeriodState } from './state';
import { PeriodType } from './action';

export const initialState: PeriodState = {
    periods: [],
};

export const periodReducer = (state: PeriodState | undefined, action: Action): PeriodState => {
    state = state ?? initialState;

    switch (action.type) {
        case PeriodType.PeriodsLoaded:
            return { ...state, periods: action.periods };
        case AuthType.TokenExpired:
            return initialState;
        default:
            return state;
    }
};
